export default __webpack_public_path__ + "static/media/7_banner-cloud.8a54fa3b.jpg";